import { render, staticRenderFns } from "./DocumentPreview.vue?vue&type=template&id=265f4183&scoped=true"
import script from "./DocumentPreview.vue?vue&type=script&lang=js"
export * from "./DocumentPreview.vue?vue&type=script&lang=js"
import style0 from "./DocumentPreview.vue?vue&type=style&index=0&id=265f4183&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265f4183",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('265f4183')) {
      api.createRecord('265f4183', component.options)
    } else {
      api.reload('265f4183', component.options)
    }
    module.hot.accept("./DocumentPreview.vue?vue&type=template&id=265f4183&scoped=true", function () {
      api.rerender('265f4183', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Documents/Conferences/DocumentPreview.vue"
export default component.exports